<div class="content">
  <div class="login">
  </div>
</div>

<!-- system跳視窗請user輸入OTP -->
<p-dialog header="{{'Two-Factor Authentication' | translate}}" [(visible)]="TwoFactorAuthDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="true" (onHide)="closeDialog()">
  <div class="dialog-content">
    <div class="content-info center auth">
      <span class="fa-stack fa-lg">
        <span class="material-icons fa-stack-2x shield">
          shield
        </span>
        <span class="material-icons fa-stack-1x key">
          key
        </span>
      </span>
      <h5 translate>Please enter OTP shown in PowerPanel Cloud APP and your e-mail</h5>
      <p-inputMask mask="999999" [(ngModel)]="OTPNumber" [ngClass]="{'ng-validDirty': dialogSaveDirty}" [disabled]="OTPOvertime" (keyup.enter)="OTPkeyupEnter($event);" (ngModelChange)="OTPNumberOnchange($event)"></p-inputMask>
      <p-message severity="error" *ngIf="dialogSaveDirty"></p-message>
      <p [ngClass]="{'message-error': OTPOvertime}">
        <span *ngIf="OTPOvertime else OTPOvertimeTrue">{{errorMsg | translate}} <br><span *ngIf="errorMsgByLock">{{'Please wait for 3 minutes before you try again.' | translate}}</span></span>
        <span class="time">
          <countdown #countdown [config]="config" (event)="handleEvent($event)"></countdown>
        </span>
      </p>
      <ng-template #OTPOvertimeTrue>
        <p style="color:red;font-weight: bolder;">{{errorMsg | translate}}</p>
        <p translate>OTP will expire in</p>
      </ng-template>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Submit' | translate}}" (click)="confrimOTPnumber();" class="{{Confirm_button}}" *ngIf="!OTPOvertime" [disabled]="OTPNumberSubmitDisabled"></button>
    <button type="button" pButton label="{{'Close' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}" *ngIf="OTPOvertime"></button>
  </ng-template>
</p-dialog>

<!-- OTP system跳錯誤訊息:*帳號鎖住3分鐘後才能重送OTP -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="OTPLockDialog" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <p translate>The OTP is no longer valid for entering because it has been submitted falsely for 5 times.</p>
      <br>
      <p translate>Please wait for 3 minutes before you try again.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- 登入失敗多次後鎖定帳號 -->
<p-dialog header="{{'Attention' | translate}}" [(visible)]="LoginLocked" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content">
    <div class="icon">
      <i class="fa fa-exclamation-circle warning"></i>
    </div>
    <div class="content-info">
      <h5>{{LoginLockedMessage | translate}}</h5>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>

<!-- sso 輸入帳號與登入帳號不一致 -->
<p-dialog header="{{'Alert' | translate}}" [(visible)]="SSOAccountNotTheSameAlert" [baseZIndex]="11000" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog setup" [closable]="false">
  <div class="dialog-content align-items-top">
    <div class="icon">
      <i class="fa fa-times-circle critical"></i>
    </div>
    <div class="content-info">
      <h5 translate>SSO Login Failed</h5>
      <p translate>Please make sure all your SSO related accounts are logged out before you proceed with a new account.</p>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="{{'Confirm' | translate}}" (click)="closeDialog();" class="{{Confirm_button}}"></button>
  </ng-template>
</p-dialog>